import { render, staticRenderFns } from "./Controls.vue?vue&type=template&id=bc682f28&scoped=true&lang=html&"
import script from "./Controls.vue?vue&type=script&lang=js&"
export * from "./Controls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc682f28",
  null
  
)

export default component.exports